/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffEditTimePayrollAdjustmentCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimePayrollAdjustmentStaffEditorCtrl', ["$filter", "$scope", "TimePayrollAdjustment", "userinfo", function($filter, $scope, TimePayrollAdjustment, userinfo) {
  $scope.adjustmentTypeMap = {
    0: {description: 'Dollar amount above normal rate', rate: 'money'},
    1: {description: 'Dollar amount below normal rate', rate: 'money'},
    2: {description: 'Fixed dollar amount', rate: 'money'},
    3: {description: 'Percentage of normal rate', rate: 'percent'}
  };

  if (userinfo.companyHasPermission('Payroll,Salary')) {
    TimePayrollAdjustment.getAllActive()
    .then(function(result) {
      $scope.adjustments = result;
    });
  }

  $scope.addPayrateAdjustment = function(selectedAdjustment) {
    if (!selectedAdjustment) {
      return;
    }

    $scope.staff.adjustments.push({
      adjustmentName: selectedAdjustment.name,
      adjustmentId: selectedAdjustment.id,
      adjustmentRate: selectedAdjustment.rate,
      adjustmentType: selectedAdjustment.type
    });
  };

  $scope.removePayrateAdjustment = function(index) {
    $scope.staff.adjustments.splice(index, 1);
  };

  $scope.addAdjustmentOptions = function() {
    var options = [];

    if (!$scope.staff) {
      return options;
    }

    angular.forEach($scope.adjustments, function(adjustment) {
      if (adjustment.allStaff === false) {
        var existing = $filter('filter')($scope.staff.adjustments, {adjustmentId: adjustment.id});

        if (existing.length === 0) {
          options.push(adjustment);
        }
      }
    });
    return options;
  };
}]);
